import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MapPin, Calendar, Clock, Check, X } from "lucide-react";
import { StatusPill } from "@/components/StatusPill";
import { toast } from "sonner";

export default function ProfessionalOffers() {
  const [offers, setOffers] = useState([]);
  const load = () => api.get("/offers").then((r) => setOffers(r.data));
  useEffect(() => { load(); }, []);

  const respond = async (id, action) => {
    try {
      await api.post(`/offers/${id}/respond`, { action });
      toast.success(action === "accept" ? "Shift accepted!" : "Offer declined");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="pro-offers-page">
      <h1 className="text-2xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Shift Offers</h1>
      {offers.map((o) => (
        <Card key={o.id} data-testid={`pro-offer-card-${o.id}`}>
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-bold text-slate-900">{o.request?.position}</div>
                <div className="text-xs text-slate-500">{o.facility?.facility_type}</div>
              </div>
              <StatusPill status={o.status} />
            </div>
            <div className="mt-3 space-y-1 text-sm text-slate-700">
              <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-brand-teal" />{o.facility?.name}, {o.facility?.city}</div>
              <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-brand-teal" />{o.request?.shift_date}</div>
              <div className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-brand-teal" />{o.request?.start_time}-{o.request?.end_time} · {o.request?.total_hours}h · {o.request?.shift_type}</div>
            </div>
            {o.request?.notes && <p className="mt-2 text-xs text-slate-600 bg-slate-50 p-2 rounded">{o.request.notes}</p>}
            {o.status === "pending" && (
              <div className="mt-4 grid grid-cols-2 gap-2">
                <Button variant="outline" size="sm" onClick={() => respond(o.id, "decline")} data-testid={`offer-decline-${o.id}`}>
                  <X className="w-4 h-4 mr-1" />Decline
                </Button>
                <Button size="sm" className="bg-brand-teal hover:bg-brand-teal/90" onClick={() => respond(o.id, "accept")} data-testid={`offer-accept-${o.id}`}>
                  <Check className="w-4 h-4 mr-1" />Accept
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      ))}
      {offers.length === 0 && <div className="text-center text-sm text-slate-500 py-12">No offers yet</div>}
    </div>
  );
}
